import NotFoundRoute from "PFApp/routes/not_found_route";
import { EnsureLoggedInAndRegistered, WithLayout } from "PFApp/routes/route_helpers";
import { RecentSearchesPage } from "PFApp/search/recent_searches_page";
import SearchComponent from "PFApp/search/search_component";
import { SearchContextProvider } from "PFApp/search/search_context";
import { Route, Routes } from "react-router";

export const SearchRoutes = () => (
  <EnsureLoggedInAndRegistered>
    <WithLayout>
      <SearchContextProvider>
        <Routes>
          <Route path="/" element={<RecentSearchesPage />} />
          <Route path=":id/:tab/:term?" element={<SearchComponent />} />
          <Route path="*" element={<NotFoundRoute />} />
        </Routes>
      </SearchContextProvider>
    </WithLayout>
  </EnsureLoggedInAndRegistered>
);
